import { useCurrentShop } from '#storefront/composables'

export function useFormatHelpers() {
  const currentShop = useCurrentShop()

  const formatCurrency = (value: number): string => {
    const locale = currentShop.value.locale ?? 'en-GB'
    const currency = currentShop.value.currency ?? 'EUR'

    // Get the formatted price without currency symbol
    const numberOnly = (value / 100).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    // For EUR, place symbol after the number
    if (currency === 'EUR') {
      return `${numberOnly} €`
    }

    // For other currencies, use standard formatting
    return (value / 100).toLocaleString(locale, {
      style: 'currency',
      currency,
    })
  }

  const formatPercentage = (
    value: number,
    options?: Intl.NumberFormatOptions,
  ): string => {
    const locale = currentShop.value.locale ?? 'en-GB'
    return value.toLocaleString(locale, {
      style: 'percent',
      ...options,
    })
  }

  return {
    formatCurrency,
    formatPercentage,
  }
}
